var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable import/no-cycle */
import React from 'react';
import styled from '@empiriecom/module-components/utils/styled-components';
import { useInView } from 'react-intersection-observer';
import cuid from 'cuid';
import Loader from '@empiriecom/module-components/Loader';
import useConfig from '../hooks/useConfig';
import imgUrlPreparer from '../../utils/imgPreparer';
import filterTimeControl from '../../utils/filterTimeControl';
import buildLinkWithArguments from '../../utils/buildLinkWithArguments';
import setTargetCookie from '../../utils/setCookie';
import ComponentRecognizer from '../ComponentRecognizer';
export var ImageTestIds;
(function (ImageTestIds) {
    ImageTestIds["Image"] = "cmsImage__testid";
})(ImageTestIds || (ImageTestIds = {}));
var StyledImg = styled.picture(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  height: auto;\n  position: relative;\n  /* workaround IE11 */\n  min-height: 1px;\n  min-width: 1px;\n\n  ", ";\n\n  ", ";\n\n  img {\n    display: block;\n    ", ";\n    height: auto;\n    ", ";\n    /* workaround IE11 */\n    min-height: 1px;\n    min-width: 1px;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  height: auto;\n  position: relative;\n  /* workaround IE11 */\n  min-height: 1px;\n  min-width: 1px;\n\n  ",
    ";\n\n  ",
    ";\n\n  img {\n    display: block;\n    ",
    ";\n    height: auto;\n    ",
    ";\n    /* workaround IE11 */\n    min-height: 1px;\n    min-width: 1px;\n  }\n"])), function (_a) {
    var customSizeType = _a.customSizeType;
    return customSizeType === 'full-width' ? 'width: 100%;' : 'max-width: 100%;';
}, function (_a) {
    var customMargin = _a.customMargin;
    return customMargin !== '' ? "margin: " + customMargin + ";" : '';
}, function (_a) {
    var customSizeType = _a.customSizeType;
    return customSizeType === 'full-width' ? 'width: 100%;' : 'max-width: 100%;';
}, function (_a) {
    var customDisplayVariant = _a.customDisplayVariant;
    return customDisplayVariant === 'circle' ? 'border-radius: 50%;' : '';
});
var InnerWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  > .component-recognizer-container {\n    position: absolute;\n    ", "\n    ", "\n    transform: ", "\n    ", ";\n    &[type='flexible_teaser'] {\n      width: 100%;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    _:-ms-lang(x),\n    &[type='flexible_teaser'] {\n      height: auto;\n    }\n\n    &[type='group'] {\n      width: auto;\n    }\n  }\n"], ["\n  > .component-recognizer-container {\n    position: absolute;\n    ",
    "\n    ",
    "\n    transform: ",
    "\n    ",
    ";\n    &[type='flexible_teaser'] {\n      width: 100%;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    _:-ms-lang(x),\n    &[type='flexible_teaser'] {\n      height: auto;\n    }\n\n    &[type='group'] {\n      width: auto;\n    }\n  }\n"])), function (_a) {
    var innerGroupAlignment = _a.innerGroupAlignment;
    switch (innerGroupAlignment) {
        case 'left':
            return 'left: 0;';
        case 'right':
            return 'right: 0;';
        default:
            return 'left: 50%;';
    }
}, function (_a) {
    var innerGroupVerticalAlignment = _a.innerGroupVerticalAlignment;
    switch (innerGroupVerticalAlignment) {
        case 'center':
        case 'stretch':
            return 'top: 50%;';
        case 'flex-end':
        case 'bottom':
            return 'bottom: 0;';
        default:
            return 'top: 0;';
    }
}, function (_a) {
    var innerGroupAlignment = _a.innerGroupAlignment;
    switch (innerGroupAlignment) {
        case 'left':
        case 'right':
            return 'translateX(0)';
        default:
            return 'translateX(-50%)';
    }
}, function (_a) {
    var innerGroupVerticalAlignment = _a.innerGroupVerticalAlignment;
    switch (innerGroupVerticalAlignment) {
        case 'center':
        case 'stretch':
            return 'translateY(-50%)';
        default:
            return 'translateY(0)';
    }
});
var StyledImgLoader = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 5rem 0;\n  width: 100%;\n\n  ", ";\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 5rem 0;\n  width: 100%;\n\n  ",
    ";\n"])), function (_a) {
    var customHeight = _a.customHeight;
    return customHeight !== '' ? "min-height: " + customHeight + "px;" : '';
});
var StyledImgWrapper = styled.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  justify-content: ", ";\n"], ["\n  display: flex;\n  justify-content: ",
    ";\n"])), function (_a) {
    var Align = _a.Align;
    switch (Align) {
        case 'left':
            return 'flex-start';
        case 'center':
            return 'center';
        case 'right':
            return 'flex-end';
        default:
            return 'unset';
    }
});
var StyledImgWrapperLink = styled.a(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  justify-content: ", ";\n"], ["\n  display: flex;\n  justify-content: ",
    ";\n"])), function (_a) {
    var Align = _a.Align;
    switch (Align) {
        case 'left':
            return 'flex-start';
        case 'center':
            return 'center';
        case 'right':
            return 'flex-end';
        default:
            return 'unset';
    }
});
var StyledSvgImage = styled.img(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  width: 100%;\n  height: auto;\n"], ["\n  width: 100%;\n  height: auto;\n"])));
var ReturnComponent = function (_a) {
    var contentData = _a.contentData;
    var _b = contentData.field_margin, fieldMargin = _b === void 0 ? '' : _b, _c = contentData.field_link, fieldLink = _c === void 0 ? '' : _c, _d = contentData.field_link_target, fieldLinkTarget = _d === void 0 ? '_self' : _d, fieldLazyload = contentData.field_lazyload, fieldDisplayVariant = contentData.field_display_variant, _e = contentData.field_alt_text, altText = _e === void 0 ? '' : _e, _f = contentData.field_image_size_type, fieldImageSizeType = _f === void 0 ? 'max-width' : _f, persistTarget = contentData.field_persist_target, _g = contentData.field_alignment, Align = _g === void 0 ? 'left' : _g, 
    /* eslint-disable @typescript-eslint/naming-convention */
    field_tracking = contentData.field_tracking, field_link_anchor = contentData.field_link_anchor, field_link_highlight = contentData.field_link_highlight, field_link_searchfilter = contentData.field_link_searchfilter, field_bonus_number = contentData.field_bonus_number;
    var hookUseInView = useInView({
        triggerOnce: true,
    });
    var config = useConfig();
    var picMob = function (url) {
        var _a, _b, _c, _d;
        return (React.createElement("source", { media: "(max-width: " + (((_b = (_a = config === null || config === void 0 ? void 0 : config.mediaBreakpoints) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.mobileMaxWidth) || '') + ")", srcSet: imgUrlPreparer(url, (_d = (_c = config === null || config === void 0 ? void 0 : config.apiCmsUrlPrefix) === null || _c === void 0 ? void 0 : _c.values) === null || _d === void 0 ? void 0 : _d.url) }));
    };
    var picTab = function (url) {
        var _a, _b, _c, _d, _e, _f;
        return (React.createElement("source", { media: "(min-width: " + ((_b = (_a = config === null || config === void 0 ? void 0 : config.mediaBreakpoints) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.tabletMinWidth) + ") and (max-width: " + ((_d = (_c = config === null || config === void 0 ? void 0 : config.mediaBreakpoints) === null || _c === void 0 ? void 0 : _c.values) === null || _d === void 0 ? void 0 : _d.tabletMaxWidth) + ")", srcSet: imgUrlPreparer(url, (_f = (_e = config === null || config === void 0 ? void 0 : config.apiCmsUrlPrefix) === null || _e === void 0 ? void 0 : _e.values) === null || _f === void 0 ? void 0 : _f.url) }));
    };
    var FinalPic = function () {
        var _a, _b, _c, _d, _e, _f;
        var checkForIntersectionObserver = 'IntersectionObserver' in window;
        var _g = checkForIntersectionObserver ? hookUseInView : [null, false], ref = _g[0], inView = _g[1];
        var useLazyLoad = (fieldLazyload && checkForIntersectionObserver) || false;
        var _h = ((_a = contentData === null || contentData === void 0 ? void 0 : contentData.image_default) === null || _a === void 0 ? void 0 : _a.data) ? contentData.image_default.data
            : {}, _j = _h.width, naturalWidth = _j === void 0 ? undefined : _j, _k = _h.height, naturalHeight = _k === void 0 ? undefined : _k;
        // @ts-ignore
        var svgFile = ((contentData === null || contentData === void 0 ? void 0 : contentData.file) && ((_b = contentData === null || contentData === void 0 ? void 0 : contentData.file[0]) === null || _b === void 0 ? void 0 : _b.url)) || '';
        var finalImage = (React.createElement(StyledImg, { customSizeType: fieldImageSizeType, customDisplayVariant: fieldDisplayVariant, customMargin: fieldMargin, "data-testid": inView ? 'lazy-loaded' : 'default' },
            contentData.image_mobile &&
                contentData.image_mobile.url &&
                picMob(contentData.image_mobile.url),
            contentData.image_tablet &&
                contentData.image_tablet.url &&
                picTab(contentData.image_tablet.url),
            contentData.image_default && (React.createElement("img", __assign({}, (naturalWidth && { width: naturalWidth }), (naturalHeight && { height: naturalHeight }), { alt: contentData.field_alternate_text ? contentData.field_alternate_text : '', src: contentData.image_default && contentData.image_default.url
                    ? imgUrlPreparer(contentData.image_default.url, (_d = (_c = config === null || config === void 0 ? void 0 : config.apiCmsUrlPrefix) === null || _c === void 0 ? void 0 : _c.values) === null || _d === void 0 ? void 0 : _d.url)
                    : '', title: contentData.field_title ? contentData.field_title : '' }))),
            contentData.file && (React.createElement(StyledSvgImage, { alt: altText, src: imgUrlPreparer(svgFile, (_f = (_e = config === null || config === void 0 ? void 0 : config.apiCmsUrlPrefix) === null || _e === void 0 ? void 0 : _e.values) === null || _f === void 0 ? void 0 : _f.url) })),
            contentData.paragraph &&
                contentData.paragraph
                    .filter(function (item) {
                    return filterTimeControl(item);
                })
                    .map(function (item) {
                    var itemID = cuid();
                    return (React.createElement(InnerWrapper, { key: itemID, innerGroupAlignment: item.field_alignment, innerGroupVerticalAlignment: item.field_vertical_alignment },
                        React.createElement(ComponentRecognizer, { content: [item] })));
                })));
        if (useLazyLoad) {
            var cHeight = contentData && contentData.image_default && contentData.image_default.data
                ? contentData.image_default.data.height
                : '100';
            if (inView) {
                return finalImage;
            }
            return (React.createElement(StyledImgLoader, { "data-testid": "lazy-wrapper", customHeight: cHeight ? cHeight.toString() : '100', ref: ref },
                React.createElement(Loader, { size: "3rem" })));
        }
        return finalImage;
    };
    if (fieldLink) {
        var onClickProp = persistTarget && { onClick: function () { return setTargetCookie(fieldLink); } };
        return (React.createElement(StyledImgWrapperLink, __assign({ href: buildLinkWithArguments(fieldLink, {
                field_tracking: field_tracking,
                field_link_anchor: field_link_anchor,
                field_link_highlight: field_link_highlight,
                field_link_searchfilter: field_link_searchfilter,
                field_bonus_number: field_bonus_number,
            }), target: fieldLinkTarget }, onClickProp, { Align: Align }),
            React.createElement(FinalPic, { "data-testid": "finalPic" })));
    }
    return (React.createElement(StyledImgWrapper, { Align: Align },
        React.createElement(FinalPic, { "data-testid": "finalPic" })));
};
var CmsImage = function (_a) {
    var contentData = _a.contentData, _b = _a.componentKey, componentKey = _b === void 0 ? cuid() : _b;
    var _c = contentData.field_tracking, tracking = _c === void 0 ? '' : _c, dataTestId = contentData.dataTestId;
    return (React.createElement("div", { className: "cms-img-wrapper", "data-testid": dataTestId || ImageTestIds.Image, "data-tracking": tracking, key: componentKey },
        React.createElement(ReturnComponent, { contentData: contentData })));
};
export default CmsImage;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=index.js.map